export class User {
    id?: string;
    uid?: string;
    email: string;
    password?: string;
    name?: string;
    lastName?: string;
    gender?: string;
    photoURL?: string;
}